var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setup-container" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          _c(
            "el-col",
            { staticClass: "content", attrs: { xs: 24, sm: 12 } },
            [
              _c("p", { staticClass: "step-text" }, [_vm._v("STEP 2 OF 3")]),
              _vm._v(" "),
              _c("h2", [_vm._v("Further Details")]),
              _vm._v(" "),
              _c("p", { staticClass: "description" }, [
                _vm._v("Just a few more steps and you’re finished!")
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "moreDetailsForm",
                  attrs: { model: _vm.moreDetailsForm, rules: _vm.formRules }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "firstName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "First Name" },
                        model: {
                          value: _vm.moreDetailsForm.firstName,
                          callback: function($$v) {
                            _vm.$set(_vm.moreDetailsForm, "firstName", $$v)
                          },
                          expression: "moreDetailsForm.firstName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "lastName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Last Name" },
                        model: {
                          value: _vm.moreDetailsForm.lastName,
                          callback: function($$v) {
                            _vm.$set(_vm.moreDetailsForm, "lastName", $$v)
                          },
                          expression: "moreDetailsForm.lastName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "phoneNumber" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 5 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "Country Code",
                                    filterable: ""
                                  },
                                  model: {
                                    value: _vm.moreDetailsForm.countryCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.moreDetailsForm,
                                        "countryCode",
                                        $$v
                                      )
                                    },
                                    expression: "moreDetailsForm.countryCode"
                                  }
                                },
                                _vm._l(_vm.countries(), function(country) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: country.code,
                                      attrs: {
                                        label:
                                          country.code + " " + country.dialCode,
                                        value: country.dialCode
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _c("b", [_vm._v(_vm._s(country.name))]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#9a9a9a" } },
                                          [
                                            _vm._v(
                                              "(" + _vm._s(country.code) + ")"
                                            )
                                          ]
                                        ),
                                        _vm._v(" " + _vm._s(country.dialCode))
                                      ])
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 16 } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { placeholder: "Mobile Number" },
                                  on: {
                                    input: function($event) {
                                      _vm.moreDetailsForm.phoneNumber = _vm.moreDetailsForm.phoneNumber.replace(
                                        /[^\d]/g,
                                        ""
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.moreDetailsForm.phoneNumber,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.moreDetailsForm,
                                        "phoneNumber",
                                        $$v
                                      )
                                    },
                                    expression: "moreDetailsForm.phoneNumber"
                                  }
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _c("i", { staticClass: "el-icon-check" })
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "abnAcn" } },
                    [
                      _c("abn-acn-input", {
                        attrs: {
                          disabled: _vm.moreDetailsForm.outsideAustralia
                        },
                        on: {
                          "company-name-found": _vm.handleCompanyNameFound
                        },
                        model: {
                          value: _vm.moreDetailsForm.abnAcn,
                          callback: function($$v) {
                            _vm.$set(_vm.moreDetailsForm, "abnAcn", $$v)
                          },
                          expression: "moreDetailsForm.abnAcn"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { display: "flex" },
                      attrs: { prop: "outsideAustralia" }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "outside-aus-checkbox",
                          on: { change: _vm.handleOutsideAustraliaChange },
                          model: {
                            value: _vm.moreDetailsForm.outsideAustralia,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.moreDetailsForm,
                                "outsideAustralia",
                                $$v
                              )
                            },
                            expression: "moreDetailsForm.outsideAustralia"
                          }
                        },
                        [_vm._v("Outside Australia")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "companyName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Company Name",
                          disabled: !_vm.moreDetailsForm.outsideAustralia
                        },
                        model: {
                          value: _vm.moreDetailsForm.companyName,
                          callback: function($$v) {
                            _vm.$set(_vm.moreDetailsForm, "companyName", $$v)
                          },
                          expression: "moreDetailsForm.companyName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.moreDetailsForm.outsideAustralia
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "businessRegistrationNumber" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Business Registration Number"
                            },
                            model: {
                              value:
                                _vm.moreDetailsForm.businessRegistrationNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.moreDetailsForm,
                                  "businessRegistrationNumber",
                                  $$v
                                )
                              },
                              expression:
                                "moreDetailsForm.businessRegistrationNumber"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.moreDetailsForm.outsideAustralia
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "agentRegistrationNumber" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder:
                                  "Agent Registration " +
                                  (_vm.isRLAMandatory() ? "" : "(Optional)")
                              },
                              on: {
                                input: function($event) {
                                  _vm.moreDetailsForm.agentRegistrationNumber = _vm.moreDetailsForm.agentRegistrationNumber.replace(
                                    /[^\d]/g,
                                    ""
                                  )
                                }
                              },
                              model: {
                                value:
                                  _vm.moreDetailsForm.agentRegistrationNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.moreDetailsForm,
                                    "agentRegistrationNumber",
                                    $$v
                                  )
                                },
                                expression:
                                  "moreDetailsForm.agentRegistrationNumber"
                              }
                            },
                            [
                              _c("template", { slot: "prepend" }, [
                                _vm._v("RLA")
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "promoCode" } },
                    [
                      _c("promo-code-input", {
                        attrs: { couponDetails: _vm.couponDetails },
                        on: { validated: _vm.handlePromoCodeValidation },
                        model: {
                          value: _vm.moreDetailsForm.promoCode,
                          callback: function($$v) {
                            _vm.$set(_vm.moreDetailsForm, "promoCode", $$v)
                          },
                          expression: "moreDetailsForm.promoCode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "next-button",
                          attrs: {
                            type: "primary",
                            disabled: _vm.isNextButtonDisabled
                          },
                          on: {
                            click: function($event) {
                              return _vm.goToTermsAndConditionsStep(
                                "moreDetailsForm"
                              )
                            }
                          }
                        },
                        [_vm._v("Next")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c78ece7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c78ece7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/userDetailsSteps/uConnectMoreUserDetailsStep.vue
// module id = null
// module chunks = 